(function () {
  'use strict';

  const section = document.querySelector('.cyo');
  if (!section) return;

  // ── State ─────────────────────────────────────────────────────────────────
  // Nothing is added to the cart until the final action.
  const state = {
    base:      { card: null, productTitle: null, variantId: null, size: null },
    laces:     { card: null, productTitle: null, variantId: null },
    accessory: { card: null, productTitle: null, variantId: null },
  };

  // ── DOM refs ──────────────────────────────────────────────────────────────
  const stepPanels  = section.querySelectorAll('.cyo__step');
  const navBtns     = section.querySelectorAll('.cyo__nav-btn');
  const slots       = section.querySelectorAll('.cyo__slot');
  const slotValues  = section.querySelectorAll('[data-slot-value]');
  const actionBtn   = section.querySelector('.cyo__action-btn');
  const loader      = section.querySelector('.cyo__loader');

  let currentStep = 0;
  let autoAdded = false;

  // ── Helpers ───────────────────────────────────────────────────────────────

  function isStepDone(step) {
    if (step === 0) return !!state.base.variantId;
    if (step === 1) return !!state.laces.variantId;
    if (step === 2) return !!state.accessory.variantId;
    return false;
  }

  function goToStep(step) {
    // Don't jump forward past incomplete steps
    for (var i = 0; i < step; i++) {
      if (!isStepDone(i)) return;
    }
    currentStep = step;

    stepPanels.forEach(function (p, i) {
      p.classList.toggle('is-active', i === step);
    });

    navBtns.forEach(function (b, i) {
      b.classList.remove('is-active', 'is-done');
      b.removeAttribute('disabled');
      if (i === step) {
        b.classList.add('is-active');
      } else if (i < step) {
        b.classList.add('is-done');
      } else {
        // Disable only if a prerequisite step is incomplete
        for (var j = 0; j < i; j++) {
          if (!isStepDone(j)) { b.setAttribute('disabled', ''); break; }
        }
      }
    });

    slots.forEach(function (s, i) {
      s.classList.toggle('is-current', i === step);
    });

    updateActionBtn();
  }

  function updateActionBtn() {
    var allDone = isStepDone(0) && isStepDone(1) && isStepDone(2);
    if (allDone) {
      actionBtn.textContent = actionBtn.dataset.labelCart || 'Add to Cart';
      actionBtn.removeAttribute('disabled');
    } else if (isStepDone(currentStep) && currentStep < 2) {
      actionBtn.textContent = actionBtn.dataset.labelContinue || 'Continue';
      actionBtn.removeAttribute('disabled');
    } else {
      actionBtn.textContent = actionBtn.dataset.labelSelect || 'Select to continue';
      actionBtn.setAttribute('disabled', '');
    }
  }

  function markSlotFilled(step, label) {
    var slot = slots[step];
    slot.classList.add('is-filled');
    slot.classList.remove('is-current');
    var thumb = slot.querySelector('.cyo__slot-thumb');
    if (thumb) {
      var stateCards = [state.base.card, state.laces.card, state.accessory.card];
      var card = stateCards[step];
      var img = card && card.querySelector('img');
      var src = img && (img.src || img.getAttribute('data-src'));
      if (src) {
        thumb.innerHTML = '<img src="' + src + '" alt="">';
      } else {
        thumb.textContent = step + 1;
      }
    }
    var val = slotValues[step];
    if (val) val.textContent = label;
  }

  // ── Nav button clicks ─────────────────────────────────────────────────────

  navBtns.forEach(function (btn, i) {
    btn.addEventListener('click', function () { goToStep(i); });
  });

  // ── Slot clicks (jump back) ───────────────────────────────────────────────

  slots.forEach(function (slot, i) {
    slot.addEventListener('click', function () { goToStep(i); });
    slot.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); goToStep(i); }
    });
  });

  // ── Action button ─────────────────────────────────────────────────────────

  actionBtn.addEventListener('click', function () {
    var allDone = isStepDone(0) && isStepDone(1) && isStepDone(2);
    if (allDone) {
      addAllToCart();
    } else if (isStepDone(currentStep) && currentStep < 2) {
      goToStep(currentStep + 1);
    }
  });

  // ── Size dialog ───────────────────────────────────────────────────────────

  var sizeOverlay    = section.querySelector('.cyo__size-overlay');
  var sizeTitleEl    = section.querySelector('.cyo__size-dialog-title');
  var sizeSubtitleEl = section.querySelector('.cyo__size-dialog-subtitle');
  var sizeBtnsEl     = section.querySelector('.cyo__size-buttons');

  var dialogTargetCard = null;

  function openSizeDialog(card) {
    dialogTargetCard = card;

    var title    = card.dataset.productTitle;
    var price    = card.dataset.productPrice;
    var variants = JSON.parse(card.dataset.variants || '[]');

    // Pre-select previously chosen size for this product
    var previousSize = (state.base.productTitle === title) ? state.base.size : null;

    sizeTitleEl.textContent    = title;
    sizeSubtitleEl.textContent = price;
    sizeBtnsEl.innerHTML       = '';

    variants.forEach(function (variant) {
      var btn = document.createElement('button');
      btn.type      = 'button';
      btn.className = 'cyo__size-btn' + (variant.available ? '' : ' is-unavailable');
      btn.textContent  = variant.title;
      btn.dataset.variantId = variant.id;

      if (!variant.available) {
        btn.setAttribute('disabled', '');
      } else {
        if (previousSize === variant.title) {
          btn.classList.add('is-active');
        }
        btn.addEventListener('click', function () {
          confirmSize({ variantId: variant.id, size: variant.title }, dialogTargetCard);
        });
      }

      sizeBtnsEl.appendChild(btn);
    });

    sizeOverlay.removeAttribute('hidden');
    // rAF ensures the hidden removal is painted before the transition starts
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        sizeOverlay.classList.add('is-open');
      });
    });
  }

  function closeSizeDialog() {
    sizeOverlay.classList.remove('is-open');
    sizeOverlay.addEventListener('transitionend', function () {
      sizeOverlay.setAttribute('hidden', '');
    }, { once: true });
  }

  function confirmSize(selectedSize, targetCard) {
    var title = targetCard.dataset.productTitle;

    state.base.card         = targetCard;
    state.base.productTitle = title;
    state.base.variantId    = selectedSize.variantId;
    state.base.size         = selectedSize.size;

    section.querySelectorAll('[data-step-panel="0"] .cyo-card').forEach(function (c) {
      c.classList.remove('is-selected');
      var badge = c.querySelector('.cyo-card__size-badge');
      if (badge) badge.textContent = '';
    });
    targetCard.classList.add('is-selected');
    var badge = targetCard.querySelector('.cyo-card__size-badge');
    if (badge) badge.textContent = selectedSize.size;

    markSlotFilled(0, title + ' \u00b7 ' + selectedSize.size);
    closeSizeDialog();
    updateActionBtn();
    setTimeout(function() { goToStep(1); }, 600);
  }

  // Close on backdrop click
  sizeOverlay.addEventListener('click', function (e) {
    if (e.target === sizeOverlay) closeSizeDialog();
  });

  // Close button
  var closeBtn = section.querySelector('.cyo__size-dialog-close');
  if (closeBtn) closeBtn.addEventListener('click', closeSizeDialog);

  // Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !sizeOverlay.hasAttribute('hidden')) closeSizeDialog();
  });

  // Base card clicks
  section.querySelectorAll('[data-step-panel="0"] .cyo-card').forEach(function (card) {
    card.addEventListener('click', function () { openSizeDialog(card); });
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openSizeDialog(card); }
    });
  });

  // ── Lace type tabs ────────────────────────────────────────────────────────

  var laceTabs   = section.querySelectorAll('.cyo__lace-tab');
  var lacePanels = section.querySelectorAll('.cyo__lace-panel');

  laceTabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var type = tab.dataset.laceType;
      laceTabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
      lacePanels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.lacePanel === type); });
    });
  });

  // ── Lace card selection ───────────────────────────────────────────────────

  section.querySelectorAll('[data-step-panel="1"] .cyo-card').forEach(function (card) {
    card.addEventListener('click', function () {
      section.querySelectorAll('[data-step-panel="1"] .cyo-card').forEach(function (c) {
        c.classList.remove('is-selected');
      });
      card.classList.add('is-selected');

      state.laces.card         = card;
      state.laces.productTitle = card.dataset.productTitle;
      state.laces.variantId    = parseInt(card.dataset.variantId, 10);

      markSlotFilled(1, card.dataset.productTitle);
      updateActionBtn();
      setTimeout(function() { goToStep(2); }, 500);
    });
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.click(); }
    });
  });

  // ── Accessory card selection ──────────────────────────────────────────────

  section.querySelectorAll('[data-step-panel="2"] .cyo-card').forEach(function (card) {
    card.addEventListener('click', function () {
      section.querySelectorAll('[data-step-panel="2"] .cyo-card').forEach(function (c) {
        c.classList.remove('is-selected');
      });
      card.classList.add('is-selected');

      state.accessory.card         = card;
      state.accessory.productTitle = card.dataset.productTitle;
      state.accessory.variantId    = parseInt(card.dataset.variantId, 10);

      markSlotFilled(2, card.dataset.productTitle);
      updateActionBtn();

      if (!autoAdded) {
        autoAdded = true;
        addAllToCart();
      }
    });
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.click(); }
    });
  });

  // ── Add all to cart ───────────────────────────────────────────────────────

  async function addAllToCart() {
    actionBtn.setAttribute('disabled', '');
    actionBtn.textContent = '\u2026';
    loader.removeAttribute('hidden');

    var items = [
      { id: state.base.variantId,      quantity: 1 },
      { id: state.laces.variantId,     quantity: 1 },
      { id: state.accessory.variantId, quantity: 1 },
    ];

    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: 'cart-counter,cart-drawer',
        }),
      });

      if (!response.ok) throw new Error('Cart error ' + response.status);

      var data = await response.json();
      loader.setAttribute('hidden', '');
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data);
      } else {
        window.location.href = '/cart';
      }

    } catch (err) {
      console.error('[CYO] Cart add failed:', err);
      loader.setAttribute('hidden', '');
      var labelError = actionBtn.dataset.labelCart || 'Add to Cart';
      actionBtn.textContent = labelError;
      actionBtn.removeAttribute('disabled');
    }
  }

})();
